import { Log } from "@domain/models/Log";

export const logsHelper = { mapLogs, mapAllUsersLogs };

function mapLogs(logs: Log[]) {
  let logsArray: string[] = [];

  for (const item of logs) {
    logsArray = logsArray.concat(item.logs.reverse());
  }
  return logsArray;
}

function extractData(logStr: string): Date | null {
  const regex = /^(\d{2})\/(\d{2})\/(\d{4}) - (\d{2}):(\d{2}):(\d{2})/;
  const match = logStr.match(regex);

  if (!match) return null;

  const [_, dd, MM, yyyy, hh, mm, ss] = match;
  return new Date(`${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}`);
}

function mapAllUsersLogs(logsArray: Log[]): string[] {
  const todosLogs: string[] = logsArray.flatMap((log) => log.logs);

  return todosLogs
    .map((log) => ({
      original: log,
      data: extractData(log),
    }))
    .filter((entry) => entry.data !== null)
    .sort((a, b) => b.data!.getTime() - a.data!.getTime())
    .map((entry) => entry.original);
}
